import AdminEmployeesComplianceController from './controller';
import adminEmployeesComplianceTemplate from './template.html';

export default {
  url:
    '/compliance?rangeEnd&rangeStart&department&regulators&locations&status&pagination&searchText&pageSize&sortType&tags&time&archived',
  stateName: 'Firm Compliance',
  data: {
    specialClass: 'fixed-sidebar'
  },
  reloadOnSearch: false,
  params: {
    rangeEnd: {
      value: undefined,
      type: 'string'
    },
    rangeStart: {
      value: undefined,
      type: 'string'
    },
    department: {
      value: undefined,
      type: 'json',
      squash: true
    },
    regulators: {
      value: undefined,
      type: 'json',
      squash: true
    },
    locations: {
      value: undefined,
      type: 'json',
      squash: true
    },
    status: {
      value: undefined,
      type: 'json',
      squash: true
    },
    searchText: {
      type: 'string',
      value: undefined
    },
    pageSize: {
      type: 'int',
      value: undefined
    },
    sortType: {
      type: 'string',
      value: undefined
    },
    tags: {
      value: undefined,
      array: true,
      type: 'string',
      squash: true
    },
    archived: {
      type: 'bool',
      value: undefined
    }
  },
  views: {
    'a@app': {
      template: adminEmployeesComplianceTemplate,
      controller: AdminEmployeesComplianceController,
      controllerAs: 'AdminEmployeesComplianceCtrl'
    }
  }
};



// WEBPACK FOOTER //
// ./src/app/controllers/admin/compliance/index.js